import React from "react";
import Header from "../../components/Header";
import AccoutSetting from "../../components/AccountSettings";
import { Link } from "react-router-dom";

import { FcGoogle } from "react-icons/fc";
import { BsApple, BsFillPersonFill } from "react-icons/bs";
import { useDispatch } from "react-redux";
import { logoutRedux } from "../../features/userSlice";
import { ImFacebook } from "react-icons/im";
import { AiFillHome } from "react-icons/ai";
import { HiOutlineLanguage } from "react-icons/hi2";
import { LOGOUT } from "../../constants/settingsStrings.js";

function LoginAgain() {
  const dispatch = useDispatch();
  dispatch(logoutRedux());

  return (
    <div className=" dark:bg-black bg-white  h-screen">
      <div className="bg-[#2A71E8] shadow w-full h-[60px]  sm:hidden mb-2"></div>
      <div className="hidden md:block">
        {" "}
        <Header />
      </div>
      <div className="sm:flex sm:space-x-10 sm:items-center  sm:justify-center">
        <div className="hidden md:block">
          {" "}
          <AccoutSetting active={LOGOUT} />
        </div>
        <div className="mt-10  sm:shadow-lg sm:w-[800px] rounded-[25px]   sm:h-[454px] grid place-content-center">
          <div className="border mt-[100px] sm:mt-0 sm:w-[231px] w-[331px] h-[316px] sm:h-[271px] rounded-[25px] border-gray-900 items-center  grid place-content-center">
            <div className="rounded-full sm:ml-14 ml-[100px] w-[90.82px] h-[90.82px]    border">
              <img
                src={require("../../assets/img/okay.png")}
                className="px-2 py-2"
              />
            </div>

            <button className=" sm:ml-8 ml-4 bg-[#2A71E8] text-white  w-[284px] h-[56px] sm:w-[151px] text-[16px]  font-bold font-sans sm:h-[30px] rounded-[25px] mt-3 ">
              <Link to="/">Log in</Link>{" "}
            </button>

            <div className="flex space-x-[10px] justify-center  items-center mt-3    cursor-pointer">
              <div class="rounded-full h-14 w-14  py-1 ">
                <FcGoogle className="w-14 h-14" />
              </div>
              <div class="rounded-full  w-14 h-14  bg-[#3C5A99] flex items-center justify-center  ">
                <ImFacebook color="white" className="w-10 h-10 " />
              </div>
              <div className="rounded-full h-14 w-14 bg-[#999999] flex items-center justify-center">
  <BsApple color="white" className="w-10 h-10" />
</div>

            </div>
          </div>
        </div>
      </div>
      <div className=" flex justify-between rounded-b-50 fixed bottom-0  sm:hidden px-5  bg-[#2A71E8] mt-5 items-center h-[76px] w-full">
        <AiFillHome color="white" size={35} />
        <HiOutlineLanguage color="white" size={35} />
        <BsFillPersonFill color="white" size={35} />
      </div>
    </div>
  );
}

export default LoginAgain;
